import { Component, OnInit, Input } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { UserService } from "src/app/shared/directives/user.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import { ProfessionnelItemService } from "src/app/professionnel/core/service/professionnel-item.service";
import { CorrigerDossier } from "src/app/mon-portefeuille/core/model/corriger-dossier";
import { CorrectionHistory } from "src/app/mon-portefeuille/core/model/correction-history";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";
import { RetournerDossierModalComponent } from "src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component";
import { ProfessionnelItem } from "src/app/professionnel/core/model/professionnel-item";
import { ConditionProfessionnel } from "src/app/professionnel/core/model/condition-professionnel";
import { ConditionProfessionnelService } from "src/app/professionnel/core/service/condition-professionnel.service";
import { FormAddConditionComponent } from "src/app/professionnel/formulaire/modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "src/app/professionnel/formulaire/modal/form-edit-condition/form-edit-condition.component";
import { UpdateInfoEntrepriseComponent } from "src/app/formulaire/modal/entreprise/update-info-entreprise/update-info-entreprise.component";
import { EditCreditModalComponent } from "src/app/professionnel/formulaire/modal/edit-credit-modal/edit-credit-modal.component";

@Component({
  selector: "app-update-dossier-info",
  templateUrl: "./update-dossier-info.component.html",
  styleUrls: ["./update-dossier-info.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class UpdateDossierInfoComponent implements OnInit {
  form2: FormGroup;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  htmlContent = "";
  retournerDossier: String;
  corrigerDossier: CorrigerDossier;

  requestId: string;
  correctionId: string;

  items: ProfessionnelItem[];
  corporate: Corporate;
  request: Request;
  correctionHistory: CorrectionHistory;

  conditions: ConditionProfessionnel[];
  conditionArray: Array<ConditionProfessionnel[]> = [];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _professionnelItemService: ProfessionnelItemService,
    private _correctionHistoryService: CorrectionHistoryService,
    private _conditionService: ConditionProfessionnelService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      check: [null, Validators.compose([Validators.required])],
      reponse: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.requestId = this._router.url.split("/")[3];
    this.correctionId = this._router.url.split("/")[4];

    this.getCorrectionHistoryById(this.correctionId);
    this.getRequestById(this.requestId);
    this.getCorporateByRequestId(this.requestId);
    this.getListProfessionnelItemByRequest(this.requestId);
  }

  getCorrectionHistoryById(correctionId) {
    this._correctionHistoryService
      .getCorrectionHistoryById(correctionId)
      .subscribe(
        (data) => {
          this.correctionHistory = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCorporateByRequestId(requestId) {
    this._corporateService.getCorporateByRequestId(requestId).subscribe(
      (data) => {
        this.corporate = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateCustomer(corporateId) {
    const modalRef = this.modalService.open(UpdateInfoEntrepriseComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.corporateId = corporateId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCorporateByRequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateCredit(professionnelItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.professionnelItemId = professionnelItemId;
    modalRef.componentInstance.workflowCode = this.request.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListProfessionnelItemByRequest(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getListProfessionnelItemByRequest(requestId) {
    this._professionnelItemService
      .getListProfessionnelItemByRequest(requestId)
      .subscribe(
        (data) => {
          this.items = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionProfessionnelsByProfessionnelItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteConditionProfessionnel(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  validUpdate(): void {
    this.corrigerDossier = new CorrigerDossier();
    this.corrigerDossier.correctionId = this.correctionId;
    this.corrigerDossier.reponse = this.htmlContent;

    this._correctionHistoryService
      .corriger(this.corrigerDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  retourner() {
    const modalRef = this.modalService.open(RetournerDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = this.correctionHistory.request.id;

    modalRef.result.then(
      (data) => {
        // on close
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
